let useTestData = true;

/* Use this scaleFactor to calibrate for 
number of sensors being used */
let scaleFactor = 100;

let updateSumScaleFactor = 5;

const numberOfDataSteps = 750;

class ArtificialSensor {

    constructor(offset) {


        this.timer = 0;
        this.d = 0;
        this.numberOfStepsCompleted = 0;

    }

    update() {

        this.timer += Math.PI / numberOfDataSteps;

        this.d = Math.sin(this.timer) + 1;

        this.numberOfStepsCompleted += 1;


    }

    shouldSwitchPhase() {
        if (this.numberOfStepsCompleted % numberOfDataSteps == 0) {
            return true;
        } else {
            return false;
        }


    }

    shouldSwitchStudy(currentStudy) {

        let scalar;
        if (currentStudy === "Pressing") {
            scalar = 1;
        } else if (currentStudy === "Shouldering") {
            scalar = 3; // shouldering has 3 phases, needs 3 cycles
        } else {
            scalar = 2;

        }

        if (this.numberOfStepsCompleted % Math.round(numberOfDataSteps * scalar) == 0) { // Allow at least 2 full cycles
            this.timer = 0;
            this.numberOfStepsCompleted = 0; // Have to reset number of steps back to 0 to count steps per study
            return true;
        } else {
            return false;
        }
    }

    getSum() {

        return this.d;
    }


}

class DataProvider {


    // The serial port:



    constructor(sketch) {

        this.sketch = sketch;

        this.s = 0;

        this.artificialSensors = [
            new ArtificialSensor(0)
        ];
        // this.internalTimer = this.internalTimerOffset;

        // console.log(this.timeStamps);

        this.scaleFactor = 60 + Math.random() * 40;
    }


    reset() {

        // Reset internal counter to 0 at start of new segment
        // for(ArtificialSensor a : artificialSensors) {

        //   a.reset();

        // }

    }

    update() {

        let updatedSum = 0;
        for (let i = 0; i < this.artificialSensors.length; i++) {

            let as = this.artificialSensors[i];
            as.update();

            let a_sum = as.getSum();

            updatedSum += a_sum;



        }
        this.s = updatedSum;
        /*
                let newTime = performance.now();
                let timeElapsed = Math.round(newTime - this.internalStartTime + this.internalTimerOffset);
                // console.log("time", timeElapsed);
                if (this.sampleData) {
                    let ti = this.sampleData.filter((d) => {
                        return d.t == timeElapsed;
                    });
                    if (ti.length >= 0) {
        
                        this.datum = ti;
                    }
        
                }
        */

    }

    shouldSwitchStudy(currentStudy) {

        let as = this.artificialSensors[0];
        if (as.shouldSwitchStudy(currentStudy) == true) {
            return true;
        } else {
            return false;
        }
    }

    shouldSwitchPhase() {

        let as = this.artificialSensors[0];
        if (as.shouldSwitchPhase() == true) {

            this.scaleFactor = 60 + Math.random() * 40;

            return true;

        } else {
            return false;
        }
    }

    sum() {

        // console.log(this.s * scaleFactor);
        return this.s * this.scaleFactor;

        /*
        let s = 0;
        if (this.datum.length > 0) {
            // console.log(this.datum);
            for (let i = 0; i < this.datum.length; i++) {

                let di = this.datum[i];
                s += di.s1 + di.s2 + di.s3 + di.s4;

            }

        }

        return s * scaleFactor;
        */

        // return this.s * scaleFactor;

    }

    updateSum(ds) {


        this.s += ds * updateSumScaleFactor;

        this.sketch.constrain(this.s, 0, 1000);
    }



}




export default DataProvider;